import { render, staticRenderFns } from "./ProfileHelp.vue?vue&type=template&id=f208924c&"
import script from "./ProfileHelp.vue?vue&type=script&lang=js&"
export * from "./ProfileHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports